export function createScrollToTopMutationObserver(
  doc: Document,
  scrollTargetSelector: string,
  observedClassNames: string[]
): MutationObserver {
  return new MutationObserver(
    scrollToTopMutationCallback(doc, scrollTargetSelector, observedClassNames)
  );
}

export function scrollToTopMutationCallback(
  doc: Document,
  scrollTargetSelector: string,
  observedClassNames: string[]
) {
  return function handleMutations(mutations: MutationRecord[]) {
    if (mutationsContainClassNames(mutations, observedClassNames)) {
      const target = doc.querySelector(scrollTargetSelector);
      if (target) {
        target.scrollTo({ top: 0, behavior: 'auto' });
      }
    }
  };
}

export function mutationsContainClassNames(
  mutations: MutationRecord[],
  classNames: string[]
): boolean {
  return mutations.some(function mutationHasObservedClass(mutation) {
    return classNames.some(function classNameIsPresent(className) {
      return mutationTargetHasClass(mutation, className);
    });
  });
}

export function mutationTargetHasClass(mutation: MutationRecord, className: string): boolean {
  return (mutation.target as HTMLElement).classList.contains(className);
}

export function elementHasClass(className: string, element: HTMLElement): boolean {
  return element.classList.contains(className);
}
